import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom'
import { TirePage } from './Pages/TirePage'
import { catalogClient } from './services/grpc';
import { guidReq,guidRes } from './generated/catalog_pb'; 
import './styles/globals.css'
import './styles/footer.css'
import Cookies from 'js-cookie';
import { AboutPage } from './Pages/About';
import Catalog from './Pages/Catalog';
import { Contact } from './Pages/Contact';
import { ProductDetail } from './Pages/Product';
import { Delivery } from './Pages/Delivery';
import { WarrantyPolicy } from './Pages/PolicySection';
import { Page } from './Pages/Page';
// Mock tire data
export default function App() {
  let isguid = Cookies.get('guid');
  if (typeof isguid != 'string') {
    const req= new guidReq();
    req.setIp(window.location.hostname);
    catalogClient.getGuid(req, {}, (err, response) => {
      if (err) {
        console.error('Error fetching guid:', err.code, err.message);
      } else {
        Cookies.set('guid', response.getGuid());
      }
    });
  }
  const guid = Cookies.get('guid');
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Catalog />} />
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/delivery' element={<Delivery/>}/>
        <Route path='/policy' element={<WarrantyPolicy/>}/>
        <Route path='/product/:id' element={<ProductDetail/>}/>
        <Route path="/:id/model/:model" element={<Catalog />} />
        <Route path="/:id" element={<Catalog />} /> 
        <Route path="/page/:pagename" element={<Page />} />
         <Route 
          path="/checkout"/>
          <Route path="/about" element={<AboutPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  )
}